export const LEGACY_GUIDE_PRODUCT_REDIRECTS = Object.freeze({
  "/service-management-guide": "/products/dynamic-qr",
  "/huong-dan-quan-ly-dich-vu": "/products/dynamic-qr",
  "/event-registration-guide": "/products/dynamic-qr",
  "/huong-dan-dang-ky-su-kien": "/products/dynamic-qr",
  "/guide-for-creating-quizzes": "/products/dynamic-qr",
  "/instructions-for-creating-quizzes": "/products/dynamic-qr",
  "/huong-dan-tao-trac-nghiem": "/products/dynamic-qr",
  "/guide-for-creating-vcard": "/products/vcard-qr",
  "/instructions-for-creating-vcard": "/products/vcard-qr",
  "/huong-dan-tao-vcard": "/products/vcard-qr",
  "/guide-for-saving-wifi-password": "/products/wifi-qr",
  "/instructions-for-saving-wifi-password": "/products/wifi-qr",
  "/huong-dan-luu-pass-wifi": "/products/wifi-qr",
  "/guide-for-creating-pdf": "/products/pdf-qr",
  "/intruction-for-creating-pdf": "/products/pdf-qr",
  "/huong-dan-tao-pdf": "/products/pdf-qr",
  "/qr-code-menu-guide": "/products/nine-menu",
  "/huong-dan-menu-qr-code": "/products/nine-menu",
  "/asset-management-guide": "/products/ninecheck",
  "/huong-dan-quan-ly-tai-san": "/products/ninecheck",
  "/huong-dan-tao-gift-code": "/products/dynamic-qr",
  "/lien-he": "/contact",
  "/goi-dich-vu": "/service-pack",
  "/products/nqr-link": "/products/short-link"
});

const normalizePathname = (pathname) => {
  const value = String(pathname || "").trim();
  if (!value) return "/";
  const withLeadingSlash = value.startsWith("/") ? value : `/${value}`;
  return withLeadingSlash.length > 1
    ? withLeadingSlash.replace(/\/+$/, "")
    : withLeadingSlash;
};

export const resolveLegacyGuideProductRedirect = (pathname) =>
  LEGACY_GUIDE_PRODUCT_REDIRECTS[normalizePathname(pathname)] || "";
